import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ReactReduxContext } from "./contextAdapter";
var createContextFromStore = function createContextFromStore(store) {
  return {
    store: store
  };
};

/* eslint-disable-next-line react/prefer-stateless-function */
export var ModernizeContext = /*#__PURE__*/function (_React$Component) {
  _inherits(ModernizeContext, _React$Component);
  var _super = _createSuper(ModernizeContext);
  function ModernizeContext() {
    _classCallCheck(this, ModernizeContext);
    return _super.apply(this, arguments);
  }
  _createClass(ModernizeContext, [{
    key: "render",
    value: function render() {
      var store = this.context.store;
      var children = this.props.children;
      return /*#__PURE__*/React.createElement(ReactReduxContext.Provider, {
        value: createContextFromStore(store)
      }, children);
    }
  }]);
  return ModernizeContext;
}(React.Component);
ModernizeContext.contextTypes = {
  store: PropTypes.shape({})
};
ModernizeContext.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export var LegacifyContext = function LegacifyContext(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (_ref2) {
    var store = _ref2.store;
    return /*#__PURE__*/React.createElement(Provider, {
      store: store
    }, /*#__PURE__*/React.createElement(React.Fragment, null, children));
  });
};
LegacifyContext.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};